import { render, staticRenderFns } from "./CompareBar.vue?vue&type=template&id=bf57b886&"
import script from "./CompareBar.vue?vue&type=script&lang=js&"
export * from "./CompareBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports